import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, downloadFile, isNullOrEmpty, closeCollapsible } from '../../../../utils/util';
import { Input, Breadcrumbs, Button, Collapsible, InfiniteScroll, Select } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import PickingService from '../../../../services/PickingService';
import ListCimFileItem from './ListCimFileItem';
import * as actionPicking from '../../../../actions/pickingAction';
import SelectItem from '../../../../components/UI/SelectItem';
import { ENUMS } from '../../../../utils/constants';

const ListCimFile = (props) => {
    const expeditionCim = props.location?.state?.expeditionCim;
    const [currentPage, setCurrentPage] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [cimFiles, setCimFiles] = useState([]);
    const [filter, setFilter] = useState(
        {
            supplier: '',
            causal: '',
            dateStart: undefined,
            dateEnd: undefined,
            filename: '',
            userName: '',
            expeditionCode: '',
            success: ''
        });

    useEffect(() => {
        setCimFiles([]);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        getFileFilter(true);
        // eslint-disable-next-line
    }, [currentPage, refresh]);

    useEffect(() => {
        if (props.cimFile?.items?.length > 0) {
            if (cimFiles.length > 0 && currentPage === 0) {
                setCimFiles([...props.cimFile.items]);
            } else {
                setCimFiles((prevState) => ([...prevState, ...props.cimFile.items]));
            }
        } else {
            setCimFiles([]);
        }

        // eslint-disable-next-line
    }, [props?.cimFile?.items]);

    const onSelectChange = (item) => {
        props.setRecord(item);
        props.history.push({
            pathname: `../picking/cimFile/details`
        });
    }

    const getFileFilter = (click) => {
        props.getFiles(Object.assign(filter, {
            PageSize: 15,
            PageIndex: click ? 0 : currentPage,
            FileCreated: !expeditionCim
        }), () => {
            closeCollapsible("collapsibleCimFile");
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const download = (filename) => {
        props.getSpreadsheet(filename, (response) => {
            downloadFile(response, filename, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", true)
        });
    }

    const search = () => {
        setCimFiles([])
        setCurrentPage(0);
        setRefresh(refresh + 1);
    }

    const redirect = () => {
        props.history.push({ pathname: './expeditionCim', state: { expeditionCim: expeditionCim } })
    }

    const handleSubtitle = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, {
            icon: "mdi mdi-file-table-outline",
            label: expeditionCim ?
                translate('expedition:picking.generate-expedition-cim') :
                translate('expedition:picking.generate-spreadsheet')
        }];
        return subtitlesItems;
    }

    const onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            filter.userName = value;
            setFilter({ ...filter });
        }
    };

    const onChangeSelectItem = (value) => {
        filter.userName = value;
        setFilter({ ...filter });
    };

    const downloadReport = () => {
        props.generateCsv(filter, (data) => {
            downloadFile(data, `ListCimFile${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    return (
        <div>
            <Breadcrumbs title={{ icon: "mdi mdi-file-document-multiple", label: translate('expedition:picking.title') }} subtitles={handleSubtitle()} />
            <i className={`mdi mdi-36px mdi-sticker-plus above-btn`} style={{ cursor: 'pointer' }} onClick={() => redirect()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', padding: '10px' }}  >
                    <Collapsible
                        id="collapsibleCimFile"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col no-padding">
                                    <div className="row">
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                defaultValue={filter.dateStart}
                                                type="date"
                                                label={translate('change-location:startDate')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                defaultValue={filter.dateEnd}
                                                type="date"
                                                label={translate('change-location:endDate')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                defaultValue={filter.causal}
                                                type="text"
                                                label="Causal"
                                                id="causal"
                                                name="causal"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                defaultValue={filter.supplier}
                                                type="text"
                                                label={translate('expedition:picking.supplier')}
                                                id="supplier"
                                                name="supplier"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                defaultValue={filter?.expeditionCode || ''}
                                                type="text"
                                                label={translate('expeditionCode', 'expedition:picking')}
                                                id="expeditionCode"
                                                name="expeditionCode"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="filename"
                                                name="filename"
                                                label={translate('expedition:picking.archive-name')}
                                                type="text"
                                                defaultValue={filter.filename || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <SelectItem
                                                id="userName"
                                                name="userName"
                                                label={translate('general:user')}
                                                onChange={(event) => onChangeSelectItem(event)}
                                                onChangeData={onChangeData}
                                                data={props.usersFromElog ? props.usersFromElog.map(item => {
                                                    return {
                                                        id: item.id,
                                                        text: item.user
                                                    }
                                                }) : []}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <label>{translate('general:status')}</label>
                                            <br></br>
                                            <Select
                                                id="success"
                                                name="success"
                                                display="description"
                                                change={onChange}
                                                defaultValue={""}
                                                placeHolder={translate('expedition:picking.all')}
                                                data={[{ id: ENUMS.eCimFileStatus.Success.value, text: translate("general:success"), },
                                                { id: ENUMS.eCimFileStatus.Error.value, text: translate("general:erro") }
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button
                                        full="true"
                                        text={translate('general:search')}
                                        onClick={() => search()}
                                    />
                                </div>
                            </>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button
                            full="true"
                            text={translate('expedition:picking.generate-csv')}
                            onClick={downloadReport}
                        />
                    </div>
                </div>
                <div id="listcim">
                    <InfiniteScroll
                        page={props.cimFile?.totalPages}
                        hasMore={currentPage < props.cimFile?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={cimFiles.map((item) => (
                            <ListCimFileItem
                                onSelectChange={(event) => onSelectChange(event)}
                                item={item}
                                onClickDownload={(i) => download(i.fileName)} />
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        cimFile: state.pickingReducer.cimFile,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFiles: (filter, callback) => {
            dispatch(PickingService.getCimFiles(filter, callback));
        },
        getSpreadsheet: (fileName, callback) => {
            dispatch(PickingService.getSpreadsheet(fileName, callback));
        },
        generateCsv: (filter, callback) => {
            dispatch(PickingService.generateCsv(filter, callback));
        },
        setRecord: (item) => {
            dispatch(actionPicking.selectCimFileItem(item));
        }
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListCimFile)));
